module.exports = __webpack_public_path__ + "img/customer11.75949105.png";